import { HTMLAttributes, forwardRef } from 'react';
import { BUNU_TERMS_OF_USE, TOLSTOY_PRIVACY_POLICY } from '@/constants/links';

interface Props extends HTMLAttributes<HTMLDivElement> {}

const Component = forwardRef<HTMLDivElement, Props>(({ className, ...props }, ref) => (
  <div ref={ref} className={`text-xs ${className} text-gray-500`} {...props}>
    <span>Use of this videos must comply with our </span>
    <a className="whitespace-nowrap underline" href={BUNU_TERMS_OF_USE} target="_blank" rel="noreferrer">
      Terms of Use
    </a>
    <span> and </span>
    <a className="whitespace-nowrap underline" href={TOLSTOY_PRIVACY_POLICY} target="_blank" rel="noreferrer">
      Privacy Policy
    </a>
    <span>. Any violation is under the user responsibility.</span>
  </div>
));

Component.displayName = 'TermsAndConditions';

export default Component;
